/** Asset classes let by the night: no rent roll, no leases, no WALT. */
const LODGING_RE = /hospitality|hotel|lodging|motel|resort/i

export function isLodging(assetType: string | null | undefined): boolean {
  return LODGING_RE.test(assetType ?? '')
}

/** What a hotel counts its units in — "Rooms" or "Keys" as the record says. */
export function keysLabel(measure: unknown): string {
  const text = measure == null ? '' : String(measure).trim()
  return text && /room|key/i.test(text) ? text : 'Keys'
}
